<script>
import { onMounted } from 'vue';
import SmartLayoutC from '@rebuild/components/SmartLayoutC.vue';
import { useBannerImage } from '@rebuild/hooks/comp/useBannerImage';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import SLIDE_MASK from '@/assets/images/slide/slide_mask.png';

export default {
	name: 'SlideLayoutWrapper',
	components: {
		SmartLayoutC,
		ContentPad
	},
	setup() {
		// ===================== Banner =====================
		const { bannerRef, initBannerImage } = useBannerImage();
		onMounted(() => {
			initBannerImage();
		});

		return {
			banner: bannerRef,
			SLIDE_MASK
		};
	},
	render() {
		const Banner = <SmartLayoutC ref="banner" compId="layout_banner" mode="basic" key="layout_banner" />;
		const Main = (
			<div class="slide-main ex2rem-min-w1200-layout-next">
				<div class="slide-main-mask-wrapper">
					<div class="slide-main-mask">
						<img src={SLIDE_MASK} alt="" />
					</div>
				</div>
				<ContentPad>
					<div class="slide-main-wrapper">
						<router-view key={this.$route.fullPath} />
					</div>
				</ContentPad>
			</div>
		);
		const Floating = <SmartLayoutC compId="layout_floating" mode="basic" key="layout_floating" />;

		let layouts = [];
		const initRender = () => {
			layouts = [Banner, Main, Floating];
		};
		initRender();

		return <div class="slide-layout ex2rem-min-w1200-layout-next">{...layouts}</div>;
	}
};
</script>

<style lang="less" scoped>
.slide-layout {
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}
.slide-main {
	flex: 1;
	height: 0;
	background-color: #f2f3f5;
	position: relative;

	.slide-main-mask-wrapper {
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
	}
	.slide-main-mask {
		position: absolute;
		top: 0;
		left: 0;
		width: 83%;
		pointer-events: none;

		img {
			width: 100%;
		}
	}
	.slide-main-wrapper {
		position: relative;
		margin: 40px auto;
		min-height: 690px;
	}
}
</style>
